import { useRef, useEffect, useState } from "react";

// Scroll-reveal wrapper. dir: "up" | "left" | "right". Slides content in on view.
export default function Reveal({ children, dir = "up", delay = 0, className = "" }) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) { setInView(true); io.disconnect(); } },
      { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  const dc = dir === "left" ? "from-left" : dir === "right" ? "from-right" : "";
  return (
    <div ref={ref} style={{ transitionDelay: `${delay}ms` }} className={`reveal ${dc} ${inView ? "in" : ""} ${className}`}>
      {children}
    </div>
  );
}
